__turbopack_context__.v({
  "body": "f5PYHq_body",
  "ctaButton": "f5PYHq_ctaButton",
});
